// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__dwMMq","RichText___bigText":"RichText_RichText___bigText__8wHc6","RichText___truncateText":"RichText_RichText___truncateText__fgvYU"};